function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useHistory } from 'react-router';
import { useOverlayContext, ConfirmationModal } from 'seagull';
import { ErrorText, routes } from "../constants";
import { useStoreActions } from "../contexts";
import { useDraftProposal } from "./reactQuery/mutations/useDraftProposal";
import { useDuplicateRelationship } from "./useDuplicateRelationship";
import { ErrorResponse, ServerError } from "../infra/ErrorResponse";
import { jsx as _jsx } from "react/jsx-runtime";
export function useWithdrawToEditProposal() {
  const overlayContext = useOverlayContext();
  const {
    duplicateRelationship
  } = useDuplicateRelationship();
  const {
    api
  } = useStoreActions();
  const history = useHistory();
  const {
    draftProposal
  } = useDraftProposal({
    onSuccess: newDraftId => history.push(routes.draft(newDraftId))
  });
  async function approveWithdrawProposal(action, errorMessage, modalProps) {
    const confirmed = await overlayContext.showModal({
      closeOnClickOutside: true,
      shouldBlurBackground: true,
      closeOnEscapeKey: true,
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/_jsx(ConfirmationModal, _objectSpread(_objectSpread({
          skin: "danger"
        }, modalProps), {}, {
          onPrimaryButtonClick: () => dismissModal(true),
          onSecondaryButtonClick: () => dismissModal(false)
        }));
      }
    });
    if (confirmed) {
      try {
        await action();
      } catch (err) {
        overlayContext.showErrorToast(errorMessage);
      }
    }
  }
  async function cancelProposal(id) {
    try {
      await api.relationship.cancelProposal(id);
    } catch (err) {
      if (new ErrorResponse(err).hasServerError(ServerError.InvalidRelationshipStatus)) {
        overlayContext.showErrorToast(ErrorText.ProposalAlreadyAcceptedOrCanceled);
      } else {
        overlayContext.showErrorToast(ErrorText.UnexpectedErrorTryAgain, 'cancel-proposal-error');
      }
      throw err;
    }
  }
  async function withdrawToEditAndRedirect(id, draftId) {
    return draftProposal({
      relationshipId: id,
      draftId
    });
  }
  return {
    withdrawToEditProposalByIdWithConfirmation: async (id, draftId) => {
      return approveWithdrawProposal(() => withdrawToEditAndRedirect(id, draftId), 'Failed to withdraw proposal for editing', {
        title: 'Withdraw to edit',
        content: 'Once you withdraw this proposal, the client’s previous link will be disabled. As soon as you send the new proposal, an email will be sent with a link to the new version.',
        primaryButtonLabel: 'Withdraw and edit',
        secondaryButtonLabel: 'Cancel'
      });
    },
    withdrawToEditProposalById: async function withdrawToEditProposalById(id) {
      let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      const draftId = await duplicateRelationship(id, {
        strategy: 'withdraw-to-edit',
        onError: opts.onDuplicateRelationshipError
      });
      await cancelProposal(id);
      return draftId;
    }
  };
}